<template>
  <div>
    <b-row>

      <b-col
        cols="12"
        class="d-flex flex-wrap align-items-center justify-content-center"
      >
        <img
          ref="refImageImg"
          class="cursor-pointer"
          fluid
          :src="businessCardTypeFinishing.image || $defaultCardTypeFinishingImage"
          width="300"
          height="300"
          data-placement="left"
          data-toggle="tooltip"
          title="Click here to upload an image"
          @click="$refs.uploadImageInput.click()"
        >
        <input
          ref="uploadImageInput"
          type="file"
          class="hidden"
          accept="image/*"
          @change="updateImage"
        >

        <div class="flex-break" />

        <!-- <h5 class=""> Finishing </h5> -->
      </b-col>

      <hr>

      <b-row class="w-100 m-2 p-1">
        <b-col
          cols="12"
        >
          <form-label> Finishing Name </form-label>
          <b-form-input
            v-model="businessCardTypeFinishing.name"
            placeholder="Name of the type"
          />
        </b-col>

        <b-col
          cols="12"
        >
          <form-label> Description </form-label>
          <b-form-textarea
            v-model="businessCardTypeFinishing.description"
            placeholder="Insert brief description of the finishing"
          />
        </b-col>
      </b-row>

      <b-row
        class="w-100 mx-1 d-flex flex-wrap align-items-center justify-content-between"
      >
        <b-button
          :variant="`outline-${$isEmpty(businessCardTypeFinishing.deactivated_at) ? 'danger' : 'success'}`"
          @click="toggleStatus"
        > {{ $isEmpty(businessCardTypeFinishing.deactivated_at) ? 'Deactivate' : 'Activate' }} </b-button>
        <b-button
          class="ml-1"
          variant="primary"
          @click="submit"
        > {{ $capitalizeString(formType) }} </b-button>
      </b-row>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    cardTypeFinishingId: {
      type: [String, Number],
      default: null,
    },
    formType: {
      type: String,
      default: 'create',
    },

    cardTypeId: {
      type: [String, Number],
      default: null,
    },
  },

  data() {
    return {
      businessCardTypeFinishing: {
        name: '',
        description: '',
        image: this.defaultCardTypeImage,
      },

      formData: new FormData(),
    }
  },
  created() {
    if (this.formType === 'edit') {
      this.getBusinessCardTypeFinishing(this.cardTypeFinishingId)
    }
  },
  methods: {
    getBusinessCardTypeFinishing(id) {
      this.$http
        .get(`/api/business-cards-types-finishings/${id}`)
        .then(response => {
          const { success, message, output } = response.data
          if (success) {
            this.businessCardTypeFinishing = output
          }
        })
        .catch(error => {
          this.$handleResponseError(error)
        })
    },

    submit() {
      // validate
      let validated = true
      let message = ''
      if (this.$isEmpty(this.businessCardTypeFinishing.name)) {
        message += 'Name'
        validated = false
      }
      message += ' is not valid'
      if (!validated) {
        this.$toastDanger('Unable To Submit', message)
        return
      }

      this.businessCardTypeFinishing.card_type_id = this.cardTypeId
      this.formData.append('form_data', JSON.stringify(this.businessCardTypeFinishing))

      const headers = {
        'Content-Type': 'multipart/form-data',
      }

      if (this.formType === 'create') {
        this.$http
          .post(
            `/api/business-cards-types-finishings`,
            this.formData,
            {
              headers,
            }
          )
          .then(response => {
            const { success, message, output } = response.data
            if (success) {
              this.businessCardTypeFinishing = output
              this.$toastSuccess('Operation Success', message)

              this.$emit('close-modal')
              this.$emit('refresh-record')
            }
          })
          .catch(error => {
            this.$handleResponseError(error)
          })
      } else if (this.formType === 'edit') {
        this.$http
          .put(
            `/api/business-cards-types-finishings/${this.cardTypeFinishingId}`,
            this.formData,
            {
              headers,
            },
          )
          .then(response => {
            const { success, message, output } = response.data
            if (success) {
              this.businessCardTypeFinishing = output
              this.$toastSuccess('Operation Success', message)
  
              this.$emit('close-modal')
              this.$emit('refresh-record')
            }
          })
          .catch(error => {
            this.$handleResponseError(error)
          })
      }
    },

    updateImage(input) {
      const file = input.target.files[0]
      this.previewImage(file, 'refImageImg')
      this.formData.append('image_file', file)
    },
    previewImage(file, imgRef) {
      const image = file
      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = e =>{
        this.$refs[imgRef].src = e.target.result
      };
    },

    toggleStatus() {
      let status = 'activate'
      if (this.$isEmpty(this.businessCardTypeFinishing.deactivated_at)) {
        status = 'deactivate'
      }

      this.$http
        .put(`/api/business-cards-types-finishings/${this.businessCardTypeFinishing.id}/${status}`)
        .then(response => {
          this.$toastSuccess('Operation Success', 'Status updated')

          this.getBusinessCardTypeFinishing(this.cardTypeFinishingId)
          // this.$emit('close-modal')
          this.$emit('refresh-record')
        })
        .catch(error => {
          this.$handleResponseError(error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
